import { useEntitlements } from "@/entitlements/useEntitlements";
import { FeatureKey } from "@/viaduct-api";

export function useModules() {
  const { checkEntitlement } = useEntitlements();

  return {
    hasEnergyManagement: checkEntitlement({
      key: FeatureKey.MODULE_ENERGY_MANAGEMENT,
    }),
    hasPerformanceCompliance: checkEntitlement({
      key: FeatureKey.MODULE_PERFORMANCE_COMPLIANCE,
    }),
    hasBuildingPerformancePrograms: checkEntitlement({
      key: FeatureKey.MODULE_BUILDING_PERFORMANCE_PROGRAMS,
    }),
  };
}
